import { MaterialGradeType, PartTypeSchema, PartTypeType } from "../types";

type Params = {
  materialGrade: MaterialGradeType | null;
  isAssembly: boolean;
  children: { materialGrade: MaterialGradeType | null; part: { type: PartTypeType | null } }[];
};

export const hasValidDataToPredict = ({ materialGrade, isAssembly, children }: Params): boolean => {
  if (isAssembly) {
    return (
      children.length > 0 &&
      children
        .filter((child) => child.part.type !== PartTypeSchema.enum.CONSUMABLE)
        .every((child) =>
          hasValidDataToPredict({
            materialGrade: child.materialGrade,
            isAssembly: false,
            children: [],
          }),
        )
    );
  }

  return !!materialGrade;
};
